import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import {
  DataTypeProvider,
  SelectionState,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  VirtualTable,
  TableSelection,
} from '@devexpress/dx-react-grid-material-ui';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { indigo } from '@material-ui/core/colors';

import RoomScheduleDetailDialog from './RoomScheduleDetailDialog.js';

import moment from 'moment';

import firebase from 'firebase/app';
require("firebase/firestore");

const cellHeight = 60;
const interval = 1000 * 60 * 30;

const styles = theme => ({
});

const columns = [
  { name: 'time' },
  { name: 'booking' },
];
const columnExtensions = [
  { columnName: 'time', width: 90 },
];

const openFrom = moment('10:00', 'HH:mm');
const openTill = moment('23:00', 'HH:mm');
const getRows = () => {
  var rows = [];
  for (var i = openFrom.valueOf(); i <= openTill.valueOf(); i+= interval) {
    rows.push({
      time: moment(i).toDate(),
    });
  }
  return rows;
};

class ScheduleTimeline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: getRows(),

      selection: [],

      detailDialogOpen: false,
      selectedSchedule: null,
      unsubscribe: null,
      now: moment(),
    };
  }

  querySchedule = () => {
    return firebase.firestore()
      .collection("schedule")
      .doc(moment().format("YYYYMMDD"))
      .collection('bookings')
      .where('roomId', '==', this.props.room.id)
      .onSnapshot(function(querySnapshot) {
        var rows = this.state.rows;
        querySnapshot.docChanges().forEach(change => {
          if (change.type === "added" || change.type === "modified") {
            let data = change.doc.data();
            data.id = change.doc.id;

            rows.forEach((row, index) => {
              if (moment(row.time).isBetween(data.bookingStartTime, data.bookingEndTime, null, '(]')) {
                rows[index].booking = data;
              }
            });
          }
        });

        this.setState({
          rows: Array.from(rows),
        });

        rows.forEach((row, index) => {
          if (row.booking) {
            this.getUserInfo(index, row.booking.userId);
          }
        });
      }.bind(this));
  }

  getUserInfo = (index, userId) => {
    firebase.firestore()
      .collection("users")
      .doc(userId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let data = doc.data();
          data.id = doc.id;

          var rows = this.state.rows;
          rows[index].booking.customer = data;

          this.setState({
            rows: Array.from(rows),
          });
        }
      });
  }

  tick = () => {
    this.setState({ now: moment() });
  }

  scrollTo = () => {
    this.now && this.now.scrollIntoView(true);
  }

  handleDetailDialogOpen = (scheduleRow) => {
    this.setState({
      detailDialogOpen: true,
      selectedSchedule: scheduleRow,
    });
  }

  handleDetailDialogClose = () => {
    this.setState({ detailDialogOpen: false });
  }

  changeSelection = selection => {
    if (!this.props.isOtherTimeRowSelected()) {
      return;
    }
    if (selection.length > 12) {
      return;
    }
    if (selection.length > 1) {
      selection.sort((a, b) => {return a - b});

      var isChained = (currentValue, index) => {
        return !this.state.rows[currentValue].booking &&
          (index === 0 || Math.abs(currentValue - selection[index - 1]) <= 1);
      }
      if (!selection.every(isChained)) {
        return;
      }
    }

    this.props.onSelectTimeRow(selection);

    this.setState({ selection: selection });
  }

  componentDidMount() {
    this.setState({ unsubscribe: this.querySchedule() });
    this.interval = setInterval(this.tick, 5000);
    this.scrollTo();
  }

  componentWillUnmount() {
    this.state.unsubscribe && this.state.unsubscribe();
    clearInterval(this.interval);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {

  }

  render() {
    // const { classes } = this.props;

    var currentBooking = this.state.rows.find(row => {
      return this.state.now.isBetween(moment(row.time).subtract(interval, 'milliseconds'), row.time, null, '[]') && row.booking;
    });
    var isNowAvailable = !currentBooking;
    var nextBooking = this.state.rows.find(row => {
      return row.booking && moment(row.booking.bookingStartTime).isAfter(this.state.now);
    });

    return(
      <div>

        <RoomScheduleDetailDialog
          open={this.state.detailDialogOpen}
          onRequestClose={this.handleDetailDialogClose}
          scheduleRow={this.state.selectedSchedule} />

        <Card>
          <CardContent>
            <Typography noWrap variant="h5" component="h2">
              {this.props.room.name}
            </Typography>
            <Typography noWrap component="p" color={isNowAvailable ? 'primary' : 'error'}>
              { isNowAvailable ? 'Now Available' : 'Now Occupied'}
            </Typography>
            <Typography noWrap component="p" color="textSecondary">
              {nextBooking ? 'Upcoming booking on ' + moment(nextBooking.booking.bookingStartTime).format('LT') : 'No Upcoming Booking...'}
            </Typography>
          </CardContent>
        </Card>

        <br/>

        <Paper>
          <Grid
            rows={this.state.rows}
            // getRowId={getRowId}
            columns={columns}>

            {/* Time Provider */}
            <DataTypeProvider
              for={['time']}
              formatterComponent={({ column, row, value }) => {
                var isNow = this.state.now.isBetween(moment(row.time).subtract(interval, 'milliseconds'), row.time, null, '[]');
                return(
                  <div
                    style={{ height: cellHeight, display: 'flex', flexFlow: 'column' }} >
                    <div style={{ flex: '1 1 auto' }} />
                    <div
                    />
                    <Typography
                      component="p"
                      color={
                        isNow ?
                        "secondary" :
                        moment(value).isBefore(moment()) ?
                        "textSecondary" :
                        "primary"
                      }
                    >
                      { moment(value).format('LT') }
                    </Typography>
                  </div>
                );
              }}
            />
            {/* Booking Provider */}
            <DataTypeProvider
              for={['booking']}
              formatterComponent={({ column, row, value }) => {
                var isStart = value && moment(value.bookingStartTime).isBetween(moment(row.time).subtract(interval, 'milliseconds'), row.time, null, '[)');
                var isEnd = value && moment(value.bookingEndTime).isBetween(moment(row.time).subtract(interval, 'milliseconds'), row.time, null, '(]');
                var isNow = this.state.now.isBetween(moment(row.time).subtract(interval, 'milliseconds'), row.time, null, '[]');

                return (
                  <div
                    style={{ display: 'table-row', height: cellHeight }}
                    ref={(element) => {
                      if (isNow) {
                        this.now = element;
                      }
                    }} >
                    { value ?
                      <div style={{ display: 'table-cell' }} >
                        <div
                          style={{
                            boxSizing: 'border-box',
                            width: 20,
                            height: cellHeight,
                            borderTop: isStart ? 'thick dotted ' + indigo[500] : '',
                            borderBottom: isEnd ? 'thick dotted ' + indigo[500] : '',
                            borderLeft: 'thick dotted ' + indigo[500],
                          }} />
                      </div>
                      : null
                    }

                    { isStart ?
                      <div style={{
                          paddingLeft: 10,
                          display: 'table-cell',
                          verticalAlign: 'middle'
                        }} >

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div>
                            <Typography noWrap variant="body2">
                              { value && value.customer && value.customer.name }
                            </Typography>
                            <Typography noWrap variant="caption">
                              { value && value.customer &&  value.customer.phone }
                            </Typography>
                          </div>
                          <IconButton onClick={() => this.handleDetailDialogOpen(value)}>
                            <MoreVertIcon />
                          </IconButton>
                        </div>

                      </div>
                      : null
                    }
                  </div>
                );
              }}
            />

            <SelectionState
              selection={this.state.selection}
              onSelectionChange={this.changeSelection}
            />

            <VirtualTable
              columnExtensions={columnExtensions}
              height={this.props.height || 500} />

            <TableSelection
              selectByRowClick
              highlightSelected
              showSelectionColumn={false}
            />

          </Grid>
        </Paper>
      </div>
    );
  }
}

ScheduleTimeline.propTypes = {
  classes: PropTypes.object.isRequired,
  room: PropTypes.object.isRequired,
  height: PropTypes.number.isRequired,
  isOtherTimeRowSelected: PropTypes.func,
  onSelectTimeRow: PropTypes.func,
};

export default withStyles(styles)(ScheduleTimeline);
